import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('clientFormFields');

    return {
        CLIENT_NAME_FIELD_PLACEHOLDER: t('clientNameFieldPlaceholder'),
        CONTACT_NAME_FIELD_PLACEHOLDER: t('contactNameFieldPlaceholder'),
        EMAIL_FIELD_PLACEHOLDER: t('emailFieldPlaceholder'),
        PHONE_NUMBER_FIELD_PLACEHOLDER: t('phoneNumberFieldPlaceholder')
    };
};

export default useTranslation;
